
export const categories = ["Red signal", "Router setup", "Billing issue", "New connection setup", "New connection survey", "CCTV survey", "CCTV setup", "Ecommerce", "Other"];
